"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormHelp = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _FormField = require("../FormField/FormField.context");
var _FormHelp = require("./FormHelp.styles");
/**
 * @related ['FieldSet', 'FormField']
 * @since 4.0.0
 */

var FormHelp = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _useContext = (0, _react.useContext)(_FormField.FormFieldContext),
    descriptionId = _useContext.descriptionId,
    error = _useContext.error;
  return /*#__PURE__*/_react.default.createElement(_FormHelp.StyledFormHelp, (0, _extends2.default)({
    ref: forwardedRef,
    id: descriptionId || undefined,
    error: error
  }, props));
});
exports.FormHelp = FormHelp;
FormHelp.displayName = 'FormHelp';
FormHelp.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Displays the form help in an error state. Usually inherited from a FormField or
   * FieldSet parent.
   */
  error: _propTypes.default.bool
} : {};